import type { Method } from 'axios';
import Axios from 'axios';

import config from '../config';
import { getAccessToken, isPublicRoute } from '../utils/api';

export const oktaReactQueryAxiosInstance = Axios.create({
  baseURL: config.API_URL,
  timeout: config.NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',

    appVersion: process.env.VITE_VERSION,
  },
});

export const jwtReactQueryAxiosInstance = Axios.create({
  baseURL: config.API_URL,
  timeout: config.NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',
    appVersion: process.env.VITE_VERSION,
  },
});

export const getReactQueryAxiosInstance = () => {
  if (isPublicRoute()) {
    return jwtReactQueryAxiosInstance;
  }
  return oktaReactQueryAxiosInstance;
};

export const makeAPIRequestReactQuery = async <Data>(
  url = '',
  params: any = {},
  method: Method = 'GET',
  opts?: Parameters<typeof oktaReactQueryAxiosInstance.request<Data>>[0],
  skipAuthCheck?: boolean,
): Promise<Data> => {
  // For authenticated routes, check token availability before making request
  // This prevents queries from attempting requests without tokens
  // Skip this check if skipAuthCheck is true (e.g., for magic link endpoints)
  if (!skipAuthCheck && !isPublicRoute()) {
    const accessToken = getAccessToken();
    if (
      !accessToken ||
      typeof accessToken !== 'string' ||
      accessToken.trim() === ''
    ) {
      return Promise.reject(
        new Error('No access token available. Request cancelled.'),
      );
    }
  }

  const instance = getReactQueryAxiosInstance();

  const request = await instance.request<Data>({
    method,
    url,
    params,
    ...opts,
  });
  return request.data;
};

export const makeAPIRequestReactQueryWithHeaders = async <Data>(
  url = '',
  params: any = {},
  headers: any = {},
  method: Method = 'GET',
  opts?: Parameters<typeof oktaReactQueryAxiosInstance.request<Data>>[0],
  skipAuthCheck?: boolean,
): Promise<Data> => {
  // For authenticated routes, check token availability before making request
  // This prevents queries from attempting requests without tokens
  // Skip this check if skipAuthCheck is true (e.g., for magic link endpoints)
  if (!skipAuthCheck && !isPublicRoute()) {
    const accessToken = getAccessToken();
    if (
      !accessToken ||
      typeof accessToken !== 'string' ||
      accessToken.trim() === ''
    ) {
      return Promise.reject(
        new Error('No access token available. Request cancelled.'),
      );
    }
  }

  const instance = getReactQueryAxiosInstance();

  const request = await instance.request<Data>({
    method,
    url,
    params,
    headers,
    ...opts,
  });
  return request.data;
};
